import { Button, ButtonColor, ButtonSize, ButtonVariant } from '@components/material-ui';
import React, { useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { SearchPadding } from '@styles/search-layout';
import { ThemeProps } from '@theme/base';
import { ZIndex } from '@styles/z-index';
import { boxShadowMixins } from '@styles/mixins';
import { mq } from '@styles/breakpoints';
import { withIsServer } from '@components/hoc';
import { useI18NextContext } from '@components/hooks';
import { useSelector } from 'react-redux';
import {
  getDealFinderHasError,
  getDealFinderIsLoading
} from '@state/slices/deal-finder-results/dealFinderResultsSelectors';

interface FilterButtonContainerProps extends ThemeProps {
  isSticky: boolean;
}
export const FilterButtonContainer: any = styled(SearchPadding)(({ theme, isSticky }: FilterButtonContainerProps) => ({
  position: 'sticky',
  top: 0,
  padding: theme.custom.spacing.medium,
  backgroundColor: theme.custom.colors.white,
  zIndex: ZIndex.FILTERS_STICKY_BUTTON,
  transition: `box-shadow ${theme.custom.transitions.default}`,
  boxShadow: isSticky ? boxShadowMixins(theme.custom.colors.group10.base).default : 'none',

  [mq.medium]: {
    display: 'none'
  }
}));

export interface MobileFilterButtonProps {
  onClick: () => void;
  isServer: boolean;
}

export const MobileFilterButton = withIsServer(({ onClick, isServer }: MobileFilterButtonProps) => {
  const t: any = useI18NextContext();
  const isLoading: boolean = useSelector(getDealFinderIsLoading);
  const hasError: boolean = useSelector(getDealFinderHasError);
  const [isMobileFiltersButtonSticky, setIsMobileFiltersButtonSticky] = useState<boolean>(false);
  const mobileFilterButtonRef: React.Ref<any> = useRef(null);
  useEffect(() => {
    if (!isServer) {
      // every time isMobileFiltersButtonSticky changes, the old event listener
      // needs to be removed and a new one needs to be created
      window.removeEventListener('scroll', handleMobileFilterResultButton);
      window.addEventListener('scroll', handleMobileFilterResultButton);

      return () => window.removeEventListener('scroll', handleMobileFilterResultButton);
    }
  }, [isMobileFiltersButtonSticky]);
  const handleMobileFilterResultButton = () => {
    if (mobileFilterButtonRef.current) {
      const top = mobileFilterButtonRef.current.getBoundingClientRect().top;
      if (top <= 0 && !isMobileFiltersButtonSticky) {
        setIsMobileFiltersButtonSticky(true);
      } else if (top > 0 && isMobileFiltersButtonSticky) {
        setIsMobileFiltersButtonSticky(false);
      }
    }
  };
  if (isLoading || hasError) {
    return null;
  }
  return (
    <FilterButtonContainer ref={mobileFilterButtonRef} isSticky={isMobileFiltersButtonSticky}>
      <Button
        label={t('filters__show-filters--label')}
        variant={ButtonVariant.OUTLINED}
        color={ButtonColor.SECONDARY}
        onClick={onClick}
        size={ButtonSize.SMALL}
      />
    </FilterButtonContainer>
  );
});
